<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <!-- 国家筛选 start -->
          <el-select
            v-if="typeof constDict.country_list === 'object'"
            v-model="countryId"
            title="选择国家"
            filterable>
            <el-option
              v-for="(option, index) in constDict.country_list"
              :key="index"
              :label="option"
              :value="index"/>
          </el-select>
          <!-- 国家筛选 end -->
          <el-row
            class="rows"
            :gutter="10">
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="11">
              <div class="rows-div">
                <p>
                  <span class="s_title">地区统计</span>
                  <el-tooltip
                    placement="top"
                    effect="light">
                    <div slot="content">
                      数据量过多时，可以使用鼠标左右拖动下方数据区域
                    </div>
                    <span><i class="el-icon-caret-left blue"/><i class="el-icon-caret-right blue"/></span>
                  </el-tooltip>
                </p>
                <div class="chart-div">
                  <bi-bar
                    :data="cityData.data"
                    :options="cityData.options"
                    :refresh.sync="cityData.refresh"
                    @reload="getCities"/>
                </div>
              </div>
              <el-row
                class="rows"
                :gutter="10">
                <el-col
                  :xs="24"
                  :sm="12"
                  :md="12"
                  :lg="12">
                  <div class="rows-div">
                    <p>
                      <span class="s_title">联系方式</span>
                    </p>
                    <div class="chart-div">
                      <bi-bar
                        :data="linkData.data"
                        :options="linkData.options"
                        :refresh.sync="linkData.refresh"
                        @reload="getLink"/>
                    </div>
                  </div>
                </el-col>
                <el-col
                  :xs="24"
                  :sm="12"
                  :md="12"
                  :lg="12">
                  <div class="rows-div">
                    <p>
                      <span class="s_title">学历占比</span>
                      <span class="s_right">
                        <el-select
                          class="jm-input90"
                          v-model="schoolType"
                          placeholder="请选择"
                          size="mini"
                          @change="getSchool">
                          <el-option
                            v-for="(option, index) in constDict.level_type"
                            :key="index"
                            :label="option"
                            :value="index"/>
                        </el-select>
                      </span>
                    </p>
                    <div class="chart-div">
                      <bi-d-pie
                        :data="schoolData.data"
                        :options="schoolData.options"
                        :refresh="schoolData.refresh"
                        @reload="getSchool"/>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row
                class="rows"
                :gutter="10">
                <el-col
                  :xs="24"
                  :sm="12"
                  :md="12"
                  :lg="12">
                  <div class="rows-div">
                    <p>
                      <span class="s_title">性别占比</span>
                      <span class="s_right">
                        <el-radio-group
                          v-if="constDict.level_type"
                          slot="head"
                          v-model="sexType"
                          size="mini"
                          @change="getSex">
                          <el-radio-button
                            v-for="(option, index) in constDict.level_type"
                            :key="index"
                            :label="index">{{ option }}</el-radio-button>
                        </el-radio-group>
                      </span>
                    </p>
                    <div class="chart-div">
                      <bi-d-pie
                        :data="sexData.data"
                        :options="sexData.options"
                        :refresh="sexData.refresh"
                        @reload="getSex"/>
                    </div>
                  </div>
                </el-col>
                <el-col
                  :xs="24"
                  :sm="12"
                  :md="12"
                  :lg="12">
                  <div class="rows-div">
                    <p>
                      <span class="s_title">背景占比</span>
                      <span class="s_right">
                        <el-radio-group
                          v-if="constDict.level_type"
                          slot="head"
                          v-model="schoolBaseType"
                          size="mini"
                          @change="getSchoolType">
                          <el-radio-button
                            v-for="(option, index) in constDict.level_type"
                            :key="index"
                            :label="index">{{ option }}</el-radio-button>
                        </el-radio-group>
                      </span>
                    </p>
                    <div class="chart-div">
                      <bi-d-pie
                        :data="schoolBaseData.data"
                        :options="schoolBaseData.options"
                        :refresh="schoolBaseData.refresh"
                        @reload="getSchoolType"/>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="13">
              <div class="rows-div">
                <p>
                  <span class="s_title">用户分布统计</span>
                  <span class="s_right">
                    <el-radio-group
                      v-if="constDict.level_type"
                      slot="head"
                      v-model="areaType"
                      size="mini"
                      @change="getArea">
                      <el-radio-button
                        v-for="(option, index) in constDict.level_type"
                        :key="index"
                        :label="index">{{ option }}</el-radio-button>
                    </el-radio-group>
                  </span>
                </p>
                <div class="map-div">
                  <div class="h-div">
                    <bi-map
                      :data="areaData.data"
                      :options="areaData.options"
                      :title="areaData.title"
                      :refresh.sync="areaData.refresh"
                      @reload="getArea"/>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BiDPie from '@/components/charts/biDPie';
import BiBar from '@/components/charts/biBar';
import BiMap from '@/components/charts/biMap';
import common from '@/pages/bi/common';

let constDict = {
  country_list: {},
  level_type: ['全部用户', '已签约', '未签约']
};

export default {
  mixins: [common],
  data() {
    return {
      constDict,
      countryId: 0,
      cityData: {
        data: [],
        options: {},
        refresh: 0
      },
      productData: {
        data: [],
        options: {},
        refresh: 2
      },
      linkData: {
        data: [],
        options: {},
        refresh: 2
      },
      schoolType: 0,
      schoolData: {
        data: [],
        options: {},
        refresh: 2
      },
      sexType: 0,
      sexData: {
        data: [],
        options: {},
        refresh: 2
      },
      schoolBaseType: 0,
      schoolBaseData: {
        data: [],
        options: {},
        refresh: 2
      },
      areaType: 0,
      areaData: {
        title: '',
        data: [],
        options: {},
        refresh: 0
      }
    };
  },
  components: {
    BiDPie, BiBar, BiMap
  },
  created() {
    this.$http
      ._get({
        url: '/index/b_i_student/index'
      })
      .then(({ data }) => {
        if (typeof data.country_list === 'object') {
          this.constDict.country_list = data.country_list;
          this.countryId = Object.keys(data.country_list)[0];
        } else {
          this.countryId = data.country_list;
        }
      });
  },
  methods: {
    init() {
      this.getCities();
      this.getProduct();
      this.getLink();
      this.getSchool();
      this.getSex();
      this.getArea();
      this.getSchoolType();
    },
    // 渠道转化
    getCities() {
      this.fetchData({
        url: '/index/b_i_student/getCitys',
        field: 'cityData',
        param: { country_id: this.countryId },
        option: {
          barWidth: '50',
          domainType: 'string',
          colors: ['#45A1FF', '#FFC800'],
          groupType: false
        }
      });
    },
    getArea() {
      this.fetchData({
        url: '/index/b_i_student/getArea',
        field: 'areaData',
        param: { country_id: this.countryId, level_type: this.areaType },
      });
    },
    getProduct() {
    },
    getLink() {
      this.fetchData({
        url: '/index/b_i_student/getLink',
        field: 'linkData',
        param: { country_id: this.countryId },
        option: {
          margin: {
            top: 50, right: 30, bottom: 20, left: 50
          },
          barWidth: '50',
          domainType: 'string',
          colors: ['#45A1FF', '#FFC800'],
          groupType: false
        }
      });
    },
    getSchool() {
      this.fetchData({
        url: '/index/b_i_student/getSchool',
        field: 'schoolData',
        param: { country_id: this.countryId, level_type: this.schoolType },
        option: {
          margin: {
            top: 50, right: 30, bottom: 20, left: 30
          },
          colors: ['#409EFF', '#BD48FF', '#FFC800', '#00E9A8', '#F83458', '#273EF0', '#FF7043'],
          labelWidthPercent: 100 / 3
        }
      });
    },
    getSex() {
      this.fetchData({
        url: '/index/b_i_student/getSex',
        field: 'sexData',
        param: { country_id: this.countryId, level_type: this.sexType },
        option: {
          margin: {
            top: 50, right: 30, bottom: 20, left: 30
          },
          colors: ['#45A1FF', '#FFC800', '#EEEEEE'],
          labelWidthPercent: 20,
        }
      });
    },
    getSchoolType() {
      this.fetchData({
        url: '/index/b_i_student/getBase',
        field: 'schoolBaseData',
        param: { country_id: this.countryId, level_type: this.schoolBaseType },
        option: {
          margin: {
            top: 50, right: 30, bottom: 20, left: 30
          },
          colors: ['#409EFF', '#BD48FF', '#FFC800', '#00E9A8', '#F83458', '#273EF0', '#FF7043'],
          labelWidthPercent: 100 / 3
        }
      });
    },
  },
  watch: {
    countryId() {
      this.$nextTick(this.init);
    }
  }
};
</script>

<style scoped>
.s_right {
  float: right;
}
.rows:last-child {
  /*margin-bottom: 200px;*/
}
.rows .rows-div {
  background-color: #FFF;
  border-radius: 5px;
  margin-top: 10px;
  padding: 10px 20px 20px 20px;
}
.rows .rows-div p {
  border-bottom: solid 1px #CCC;
  padding: 10px 0px;
}
.rows .rows-div .map-div {
  height: 920px;
}
.rows .rows-div .h-div {
  height: 595px;
}
.rows .rows-div .chart-div {
  height: 250px;
}
.s_title {
  font-size: 18px;
}
.v-number span {
  text-align: center;
  display: block;
  margin-top: 13px;
}
.v-number b {
  font-size: 25px;
  font-weight: 600;
  text-align: center;
  margin-top: 10px;
  display: block;
}
.v-number:nth-of-type(1) b {
  color: #67c23a;
}
.v-number:nth-of-type(2) b {
  color: #e6a23c;
}
.v-number:nth-of-type(3) b {
  color: #f56c6c;
}
.v-number i {
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  color: #333;
}
</style>
